import React from 'react';
import Glide from '@glidejs/glide';

type QuoteSliderProps = {
    peek?: string;
    time?: string;
    block?: any;
    title?: string;
    perView?: string;
    pauseOnHover?: string;
    ctaText?: string;
    ctaLink?: string;
    ctaTextTwo?: string;
    ctaLinkTwo?: string;
};

function QuoteSlider(props: QuoteSliderProps) {
    const blocks = props.block.innerBlocks.map((block: any) =>
        Object.fromEntries(block.attributes.map((item: any) => [item.name, item.value]))
    );
    const wrapperRef = React.useRef<HTMLDivElement>(null);
    const glideRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        let glides: Glide;
        let paused: boolean;
        let index: number;
        const defaultTime = 0;
        const pauseOnHover = false;

        function mountSlides() {
            const perView = 1;

            if (wrapperRef.current) {
                wrapperRef.current.style.opacity = '1';

                // @ts-ignore
                glides = new Glide(glideRef.current, {
                    type: 'carousel',
                    focusAt: 'center',
                    startAt: index ?? 1,
                    autoplay: paused ? false : defaultTime || 4000,
                    hoverpause: true || pauseOnHover,
                    perView,
                    gap: 24,
                    peek: 1,
                    cloningRatio: 0,
                });

                glides.mount();

                const selector = glides.selector as unknown as HTMLDivElement;

                glides.on('move', () => {
                    selector.classList.add('glide__moving');
                });
                glides.on('move.after', () => {
                    setTimeout(() => {
                        if (!selector.classList.contains('glide--dragging')) {
                            selector.classList.remove('glide__moving');
                        }
                        index = glides.index;
                    }, 50);
                });

                glides.on('swipe.end', () => {
                    setTimeout(() => {
                        glides.pause();
                        paused = true;
                    }, 1000);
                });
            } else {
                setTimeout(mountSlides, 200);
            }
        }

        mountSlides();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    glides.enable();
                    glides.play();
                    // @ts-ignore
                    glides._c.Autoplay.start();
                } else {
                    glides.pause();
                    glides.disable();
                    // @ts-ignore
                    glides._c.Autoplay.stop();
                }
            });
        });

        observer.observe(glideRef.current!);

        return () => {
            glides.destroy();
            observer.disconnect();
        };
    }, []);

    return (
        <div className="wrapper black flex highlights" style={{ backgroundColor: '#FFF7DE' }}>
            <div className="content" style={{ width: '100%' }}>
                <div
                    className="beehive-h1 black weight-black center-align"
                    dangerouslySetInnerHTML={{ __html: props.title || '' }}
                />
                <div className="wrapper" ref={wrapperRef}>
                    <div className="glide" ref={glideRef}>
                        <div className="glide__track" data-glide-el="track">
                            <ul className="glide__slides">
                                {blocks.map((block: any, index: number) => (
                                    <li className="glide__slide" data-key={index} key={index}>
                                        <div
                                            className="center-align flex h-center post-description"
                                            style={{ width: '100%' }}
                                        >
                                            <div className="quote-container">
                                                <div className="quote">
                                                    <p className="black">{block.title}</p>

                                                    <svg
                                                        className="quotation left"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 34 26"
                                                    >
                                                        <path
                                                            fill="#FFC629"
                                                            stroke="#1D252C"
                                                            strokeLinejoin="round"
                                                            strokeWidth="1.5"
                                                            d="M15.7 18.7c0-3.6-2.3-6.2-6.4-6.2-.8 0-1.6.3-1.8.4.2-3.8 4.1-6 7-6.3V1C9 1.4 1 5.4 1 16.7 1 21 3.7 25 8.7 25c4 0 7-2.9 7-6.3Zm17.3 0c0-3.6-2.3-6.2-6.4-6.2-.8 0-1.7.3-1.8.4.2-3.8 4-6 7-6.3V1c-5.5.4-13.4 4.4-13.4 15.7 0 4.2 2.6 8.3 7.5 8.3 4.1 0 7.1-2.9 7.1-6.3Z"
                                                        />
                                                    </svg>
                                                    <svg
                                                        className="quotation right"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 34 26"
                                                    >
                                                        <path
                                                            fill="#FFC629"
                                                            stroke="#1D252C"
                                                            strokeLinejoin="round"
                                                            strokeWidth="1.5"
                                                            d="M18.3 7.3c0 3.6 2.3 6.2 6.4 6.2.8 0 1.6-.3 1.8-.4-.2 3.8-4.1 6-7 6.3V25C25 24.6 33 20.6 33 9.3 33 5 30.3 1 25.3 1c-4 0-7 2.9-7 6.3ZM1 7.3c0 3.6 2.3 6.2 6.4 6.2.8 0 1.7-.3 1.8-.4-.2 3.8-4 6-7 6.3V25c5.5-.4 13.4-4.4 13.4-15.7C15.6 5 13 1 8.1 1 4 1 1 3.9 1 7.3Z"
                                                        />
                                                    </svg>
                                                </div>
                                                <p className="author black weight-bold">
                                                    - {block.author}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="glide__controls">
                            <div className="glide__arrows" data-glide-el="controls">
                                <button
                                    className="glide__arrow glide__arrow--left"
                                    data-glide-dir="<"
                                >
                                    <svg
                                        width="17"
                                        height="26"
                                        viewBox="0 0 17 26"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            opacity="0.4"
                                            d="M13 22L4 13L13 4"
                                            stroke="#FFC629"
                                            strokeWidth="8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                            </div>

                            <div className="glide__bullets" data-glide-el="controls[nav]">
                                {blocks.map((_block: any, index: number) => (
                                    <button
                                        className="glide__bullet"
                                        data-glide-dir={`=${index}`}
                                        key={index}
                                    ></button>
                                ))}
                            </div>

                            <div className="glide__arrows" data-glide-el="controls">
                                <button
                                    className="glide__arrow glide__arrow--right"
                                    data-glide-dir=">"
                                >
                                    <svg
                                        width="17"
                                        height="26"
                                        viewBox="0 0 17 26"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            opacity="0.4"
                                            d="M4 4L13 13L4 22"
                                            stroke="#FFC629"
                                            strokeWidth="8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { QuoteSlider };
